import { type TypographyCommon, type Variant } from './types'
import { BaseTypography } from './BaseTypography'

type Props = TypographyCommon<{
  /**
   * Set your color
   * @default 'primary'
   */
  variant?: Variant<'primary' | 'secondary' | 'tertiary' | 'goGreen'>
}>

/**
 * Demos:
 * - [Subtitle2](https://design-system.accept.cl1.intra.dhlparcel.io/?path=/story/primitives-typography--subtitle-2)
 *
 */

export const Subtitle2 = ({ children, variant = 'primary', ...rest }: Props) => (
  <BaseTypography variant="subtitle2" color={variant} {...rest}>
    {children}
  </BaseTypography>
)
